/*
 * Author: Dw
 * File Created: Friday, 24-07-19 10:25 pm
 * Last Modified: Tuesday, 25-02-11 04:02 pm, by Harper Yan
 */

import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';
import { Icon } from '@/Icon';
// 自定义选中的圆形图标

type CheckboxThemeOptions = {
  defaultProps?: ComponentsProps['MuiCheckbox'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiCheckbox'];
  variants?: ComponentsVariants<Theme>['MuiCheckbox'];
};
export const MuiCheckbox: CheckboxThemeOptions = {
  defaultProps: {
    // icon: ,
    checkedIcon: <Icon name="CheckBoxChecked" sx={{
      fontSize: '13px',
      color: '#B69FFF'
    }} />,
    icon: <Icon name="CheckBoxUnChecked" sx={{
      fontSize: '13px',
      color: '#848E9C'
    }}></Icon>
  },
  styleOverrides: {
    root: {
      ':hover': {
        backgroundColor: 'transparent'
      }
    }
  }
};